import { useCallback, useEffect, useMemo, useState } from 'react';
import { MEAL_TYPE_MAP } from '../../config/meal-config';
import { MODAL_VIEWS } from '../../modal/modalViews';
import { ModalEntryProvider } from '../../context/ModalEntryContext';
import { ModalControllerProvider } from '../../context/ModalControllerContext';

const INITIAL_SAVED_MEALS = {
    breakfast: [],
    lunch: [],
    dinner: [],
    snack: [],
    other: []
};

const DiaryModal = ({ currentDay, controller, meals, exerciseSession }) => {
    const [savedMeals, setSavedMeals] = useState(INITIAL_SAVED_MEALS);
    const [savedExercises, setSavedExercises] = useState([]);

    const handleAddSavedMeal = useCallback((mealType, meal) => {
        const mealKey = MEAL_TYPE_MAP[mealType];

        setSavedMeals((prev) => ({
            ...prev,
            [mealKey]: [...(prev[mealKey] || []), meal]
        }));
    }, []);

    const handleAddSavedExercise = useCallback((exercise) => {
        setSavedExercises((prev) => [...prev, exercise]);
    }, []);

    useEffect(() => {
        document.body.classList.add('modal-open');
        return () => document.body.classList.remove('modal-open');
    }, []);

    const ViewComponent = useMemo(() => MODAL_VIEWS[controller.view], [controller.view]);

    if (!ViewComponent) return null;

    return (
        <div className="modal" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <ModalControllerProvider controller={controller}>
                        <ModalEntryProvider
                            entryType={controller.entryType}
                            mealId={controller.mealId}
                            meals={meals}
                            exerciseSession={exerciseSession}
                            initialPayload={controller.viewPayload}
                        >
                            <ViewComponent
                                currentDay={currentDay}
                                savedMeals={savedMeals}
                                onAddSavedMeal={handleAddSavedMeal}
                                savedExercises={savedExercises}
                                onAddSavedExercise={handleAddSavedExercise}
                            />
                        </ModalEntryProvider>
                    </ModalControllerProvider>
                </div>
            </div>

            <div className="modal-backdrop fade in" onClick={controller.close} />
        </div>
    );
};

export default DiaryModal;
